"use strict";

var _interopRequireDefault = require("/Users/vagrant/git/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("core-js/modules/es6.regexp.to-string");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/web.dom.iterable");
var _apolloClient = require("@/apollo/apolloClient");
var _zoneQuery = require("@/apollo/queries/zone-query");
var _zoneMutation = require("@/apollo/mutations/zone-mutation");
var _auth = require("@/utils/auth");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var PERSONAL_FIELDS = [{
  key: 'full_name_editable',
  label: '氏名'
}, {
  key: 'full_name_furigana_editable',
  label: '氏名ふりがな'
}, {
  key: 'position_editable',
  label: '役職名'
}, {
  key: 'birthday_editable',
  label: '生年月日'
}];
var COMPANY_FIELDS = [{
  key: 'company_name_editable',
  label: '会社名'
}, {
  key: 'company_name_furigana_editable',
  label: '会社名ふりがな'
}, {
  key: 'postcode_editable',
  label: '郵便番号'
}, {
  key: 'address_1_editable',
  label: '会社所在地'
}, {
  key: 'address_2_editable',
  label: 'ビル名'
}, {
  key: 'phone_number_editable',
  label: '電話番号'
}, {
  key: 'fax_editable',
  label: 'FAX'
}, {
  key: 'company_mobile_phone_editable',
  label: '携帯電話'
}, {
  key: 'email_editable',
  label: 'Email'
}, {
  key: 'website_editable',
  label: 'ホームページ'
}, {
  key: 'employees_editable',
  label: '社員数'
}, {
  key: 'employees_part_time_editable',
  label: 'パート・アルバイト数'
}, {
  key: 'capital_stock_editable',
  label: '資本金'
}, {
  key: 'established_editable',
  label: '設立年月日'
}, {
  key: 'business_descriptions_editable',
  label: '事業内容'
}];
var ALL_FIELDS = [].concat(PERSONAL_FIELDS, COMPANY_FIELDS);
function createDefaultForm() {
  var form = {};
  ALL_FIELDS.forEach(function (f) {
    form[f.key] = true;
  });
  return form;
}
var _default = exports.default = {
  name: 'EditableFieldSettings',
  data: function data() {
    return {
      loading: false,
      saving: false,
      zoneId: null,
      form: createDefaultForm(),
      personalFields: PERSONAL_FIELDS,
      companyFields: COMPANY_FIELDS
    };
  },
  created: function () {
    var _created = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
      return (0, _regenerator2.default)().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            if (!(0, _auth.getClaimToken)()) {
              _context.n = 1;
              break;
            }
            this.zoneId = (0, _auth.getClaimToken)().toString().trim();
            _context.n = 1;
            return this.fetchSettings();
          case 1:
            return _context.a(2);
        }
      }, _callee, this);
    }));
    function created() {
      return _created.apply(this, arguments);
    }
    return created;
  }(),
  methods: {
    fetchSettings: function () {
      var _fetchSettings = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var _this = this;
        var res, setting, _t;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              this.loading = true;
              _context2.p = 1;
              _context2.n = 2;
              return _apolloClient.apolloClient.query({
                query: _zoneQuery.GET_ZONE_PROFILE_SETTING,
                variables: {
                  zoneID: this.zoneId
                },
                fetchPolicy: 'no-cache'
              });
            case 2:
              res = _context2.v;
              setting = res.data.zone_profile_setting_by_pk;
              if (setting) {
                ALL_FIELDS.forEach(function (f) {
                  _this.form[f.key] = setting[f.key];
                });
              }
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t = _context2.v;
              this.$message.error('設定の取得に失敗しました');
              console.error(_t);
            case 4:
              _context2.p = 4;
              this.loading = false;
              return _context2.f(4);
            case 5:
              return _context2.a(2);
          }
        }, _callee2, this, [[1, 3, 4, 5]]);
      }));
      function fetchSettings() {
        return _fetchSettings.apply(this, arguments);
      }
      return fetchSettings;
    }(),
    save: function () {
      var _save = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3() {
        var _this2 = this;
        var changes, _t2;
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              this.saving = true;
              _context3.p = 1;
              changes = {};
              ALL_FIELDS.forEach(function (f) {
                changes[f.key] = _this2.form[f.key];
              });
              _context3.n = 2;
              return _apolloClient.apolloClient.mutate({
                mutation: _zoneMutation.UPDATE_ZONE_PROFILE_SETTING,
                variables: {
                  zoneID: this.zoneId,
                  changes: changes
                }
              });
            case 2:
              this.$message.success('保存しました');
              _context3.n = 4;
              break;
            case 3:
              _context3.p = 3;
              _t2 = _context3.v;
              this.$message.error('保存に失敗しました');
              console.error(_t2);
            case 4:
              _context3.p = 4;
              this.saving = false;
              return _context3.f(4);
            case 5:
              return _context3.a(2);
          }
        }, _callee3, this, [[1, 3, 4, 5]]);
      }));
      function save() {
        return _save.apply(this, arguments);
      }
      return save;
    }()
  }
};